import React, {Component} from 'react';
import { Route, BrowserRouter, Switch, Redirect } from 'react-router-dom'
import LoginComponent from './login'
import AppComponent from './application'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import {HotKeys} from 'react-hotkeys';

// import { PrivateRoute } from './application/components/routes/PrivateRoute'


const muiTheme = getMuiTheme({
	palette: {
		textColor: '#000',
		primary1Color: '#019000'
	}
});

const hotkeysMap = {
	'savePromotion': 'command+shift+s'
};

class App extends Component {
	componentDidMount() {
		// api.settings.campaigns.listenToChanges();
	}


	render() {
		return (
			<HotKeys keyMap={hotkeysMap}>
				<MuiThemeProvider muiTheme={muiTheme}>
					<BrowserRouter>
						<Switch>
							<Route path="/app" component={AppComponent} />
							<Route path="/login" exact component={LoginComponent} />
							<Redirect to="/login" />
						</Switch>
					</BrowserRouter>
				</MuiThemeProvider>
			</HotKeys>
		)
	}
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js